import React, { useState, useEffect, useRef } from 'react';
import { motion } from "framer-motion";
import TablaTiempos from './TablaTiempos';
import { abrirBaseDeDatosLocal, backupTiemposLocales, registrarCronometro, traerEstadosCronometros } from '../controllers/configuracionFirebase';
import { planillaToExcel } from '../controllers/xlsx';
import { datosAdmin } from '../controllers/administrador';
import toast from 'react-hot-toast';
import { Button } from 'primereact/button';
import Cronometro from './Cronometro';
import { Dialog } from 'primereact/dialog';

const Tiempos = ({ idTorneoParticipando, pruebasCompletas, planilla, torneoEspecifico, usuario, listadoCategorias, fechaGoogle, recordsEvento}) => {

  const [ datosCronometros, setDatosCronometros ] = useState({});
  const [ cronometrosActivos, setCronometrosActivos ] = useState([]);
  const [ prueba, setPrueba ] = useState(1);
  const [ serie, setSerie] = useState(1);
  const [ nadadoresCarriles, setNadadoresCarriles ] = useState([]);
  const [ indexJornada, setIndexJornada ] = useState(0);
  const [ cantJornada, setCantJornada ] = useState([]);
  const [ backup, setBackup ] = useState([]);
  const [ tiemposRegistrados, setTiemposRegistrados ] = useState([]);
  const [ automatico, setAutomatico ] = useState(false);
  const [ autorizacion, setAutorizacion ] = useState(false);
  const [ voces, setVoces ] = useState([]);
  const [ voz, setVoz ] = useState();
  const [ vozVelocidad, setVozVelocidad ] = useState(1);
  const [ dialogVoces, setDialogVoces ] = useState(false);
  
  const codigoAutorizacion = 'pws24142023';
  const formulariosRef = useRef([]);
  const seriesRef = useRef([]);

  function sacarDeportistas(){
    setNadadoresCarriles(planilla);
  }

  function controlJornadas(){
    const aux = [];
    for (let i = 0; i < pruebasCompletas.length; i++) {
      aux.push(i + 1);
    }
    setCantJornada(aux);
  }

  function sacarIndexJornada(index){
    setIndexJornada(index);
    if(usuario.nombreclub === datosAdmin.nombre || usuario.nombreclub === 'PROWEBSPORTS'){
      backupTiemposLocales(idTorneoParticipando, setBackup);
    }
    for (let i = 0; i < document.getElementsByClassName('cro').length; i++) {
      document.getElementsByClassName('cro')[i].value = '0';
    }
  }

  const asignarJPS = () => {
    const auxPrueba = document.getElementById('prueba').value;
    const auxSerie = document.getElementById('serie').value;

    setPrueba(parseInt(auxPrueba));
    setSerie(auxSerie);
    for (let i = 0; i < 10; i++) {
      registrarCronometro(i, {carril: i, estado: "stop", prueba: auxPrueba, serie: auxSerie, tiempo: '0:0:0'});
    }
    toast.success(`La prueba numero ${auxPrueba} y la serie numero ${auxSerie} se han activado correctamente.`);
  }

  function validarAcceso(e){
    e.preventDefault();
    const codigo = e.target.codigo.value;
    if(codigo === codigoAutorizacion){
      setAutorizacion(true);
    }else{
      toast.error('¡Ups! Código incorrecto.');
    }
    e.target.reset();
  }

  function limpiarCategoria(texto) {
  return texto
    // elimina (F) (M) (X)
    .replace(/\([FMX]\)/gi, "")
    // elimina F M X sueltos como palabra
    .replace(/\b[FMX]\b/gi, "")
    // limpia espacios dobles
    .replace(/\s+/g, " ")
    .trim();
}

  const hablarPreventivo = (prueba, nadadores, serie) => {
    let text = `¡Llamado Preventivo! ¡Prueba ${prueba.id} ${prueba.prueba.prueba}! ¡Categoría ${limpiarCategoria(prueba.categoria)} ${prueba.genero}! ¡Serie ${serie}!`;
    nadadores[serie - 1].nadadores.forEach((nad)=>{
      if(nad.nombre[0]){
        text += `¡Carril ${nad.carril}! ¡${nad.nombre}, de ${nad.nombreclub}!.\n`;
      }
    })
    const mensaje = new SpeechSynthesisUtterance(text);
    const auxVoz = voces.find(v => v.name === voz);
    mensaje.voice = auxVoz;
    mensaje.rate = parseFloat(vozVelocidad);

    speechSynthesis.speak(mensaje);
  };
  
  const hablarPausar = () => {
    window.speechSynthesis.cancel();
  };
  
  const hablarDefinitivo = (prueba, nadadores, serie) => {
    let text = `¡Llamado Definitivo! ¡Prueba ${prueba.id} ${prueba.prueba.prueba}! ¡Categoría ${limpiarCategoria(prueba.categoria)} ${prueba.genero}! ¡Serie ${serie}!`;
    nadadores[serie - 1].nadadores.forEach((nad)=>{
      if(nad.nombre[0]){
        text += `¡Carril ${nad.carril}! ¡${nad.nombre}, de ${nad.nombreclub}!.\n`;
      }
    })
    text += `¡Nadador${prueba.genero === 'Femenino' ? 'as' : 'es'}! ¡a ordenes del juez!`;
    const mensaje = new SpeechSynthesisUtterance(text);
    const auxVoz = voces.find(v => v.name === voz);
    mensaje.voice = auxVoz;
    mensaje.rate = parseFloat(vozVelocidad);

    speechSynthesis.speak(mensaje);
  };

  useEffect(() => {
    sacarDeportistas();
    controlJornadas();
  }, [])

  useEffect(() => {
    if(usuario.nombreclub === datosAdmin.nombre || usuario.nombreclub === 'PROWEBSPORTS'){
      abrirBaseDeDatosLocal(idTorneoParticipando);
    }
  },[usuario])

  useEffect(() =>{
    if(usuario.nombreclub === datosAdmin.nombre || usuario.nombreclub === 'PROWEBSPORTS'){
      backupTiemposLocales(idTorneoParticipando, setBackup);
    }
  },[usuario, indexJornada])

  useEffect(() =>{
    backup.forEach((back) =>{
      pruebasCompletas[indexJornada].forEach((prue)=>{
        if((prue.id - 1) === Math.floor(back.id)){
          nadadoresCarriles[prue.id - 1].forEach((seri) => {
            seri.nadadores.forEach((nad) => {
              const backNad = back.nadadores.find((backN) => nad.identificacion[0] === backN.identificacion);
    
              if (backNad) {
                const auxTiempo = backNad.tiempo.split(':');
                if(document.getElementById(`${prue.id - 1}tiempo${parseInt(backNad.carril)}minserie${backNad.serie}`)){
                  document.getElementById(`${prue.id - 1}tiempo${parseInt(backNad.carril)}minserie${backNad.serie}`).value = auxTiempo[0];
                  document.getElementById(`${prue.id - 1}tiempo${parseInt(backNad.carril)}segserie${backNad.serie}`).value = auxTiempo[1];
                  document.getElementById(`${prue.id - 1}tiempo${parseInt(backNad.carril)}miliserie${backNad.serie}`).value = auxTiempo[2];
                }
              }
            });
          });
        }
      })
    })
  },[backup, indexJornada])

  useEffect(() =>{
    if(backup.length !== 0){
      const auxTiemposRegistrados = [...tiemposRegistrados];
      backup.forEach((back)=>{
        auxTiemposRegistrados[back.id] = back.seriesRegistradas;
      })
      setTiemposRegistrados(auxTiemposRegistrados);
    }
  },[indexJornada, backup])

  useEffect(() => {
    if(torneoEspecifico.cronometros === 'si'){
      traerEstadosCronometros(setDatosCronometros);
    }
  }, []);

  useEffect(() =>{
    function sacarObjetosConEnteros(obj) {
      const auxCronometrosActivos = [];
      for (let key in obj) {
        const valorPrueba = obj[key].prueba;
    
        if (Number.isInteger(valorPrueba)) {
          auxCronometrosActivos.push(obj[key]);
        }
      }

      return auxCronometrosActivos;
    }

    setCronometrosActivos(sacarObjetosConEnteros(datosCronometros));
  },[datosCronometros])

  useEffect(() =>{
    function encontrarObjetoConPrimerEntero(obj) {
      const enteros = [];
      for (let key in obj) {
        const valorPrueba = obj[key].prueba;
    
        // Verificamos si el valor convertido es un número entero
        if (Number.isInteger(valorPrueba)) {
          enteros.push(obj[key]);
        }
      }
      
      return enteros;
    }

    function buscarIndexJornada(prueba){
      pruebasCompletas.forEach((prue, indexPrue)=>{
        const auxPruebaEncontrada = prue.filter((auxPrue) => auxPrue.id === parseInt(prueba));
        if(auxPruebaEncontrada.length !== 0){
          if(indexPrue !== indexJornada){
            setIndexJornada(indexPrue);
          }
        }
      })
    }

    const carrilMitad = Math.round(encontrarObjetoConPrimerEntero(datosCronometros).length / 2);
    const cronos =  Object.values(datosCronometros);
    if(carrilMitad !== 0 && autorizacion){
      document.getElementById('prueba').value = cronos[carrilMitad].prueba;
      document.getElementById('serie').value = cronos[carrilMitad].serie;
      setPrueba(cronos[carrilMitad].prueba);
      setSerie(cronos[carrilMitad].serie);
      buscarIndexJornada(cronos[carrilMitad].prueba);
    }else{
      if(cronos[1]){
        setPrueba(cronos[1].prueba);
        setSerie(cronos[1].serie);
        buscarIndexJornada(cronos[1].prueba);
      }
    }
  },[datosCronometros])

  useEffect(() =>{
    function activarEnvioFormulario() {
      const cronometrosEnStop = cronometrosActivos.every((cro)=> cro.tiempo !== '0:0:0' && cro.estado === 'stop');
      if (formulariosRef?.current[parseInt(prueba)] && planilla[prueba - 1]?.length !== 0 && cronometrosEnStop && automatico) {
        formulariosRef.current[parseInt(prueba)].dispatchEvent(new Event("submit", { cancelable: true, bubbles: true })); // Disparar el evento de submit
        if(seriesRef.current[`${parseInt(prueba)}-${serie + 1}`]){
          seriesRef.current[`${parseInt(prueba)}-${serie + 1}`].scrollIntoView({ behavior: "smooth", block: "center" });
        }
      }
    }
    activarEnvioFormulario();
  },[indexJornada, cronometrosActivos])

  useEffect(() => {
    const cargarVoces = () => {
      const lista = window.speechSynthesis.getVoices();
      setVoces(lista.filter(v => v.lang.startsWith("es")));
    };

    cargarVoces();
    window.speechSynthesis.onvoiceschanged = cargarVoces;
  }, []);

  return (
    !autorizacion ? (
      <div className='bg-light d-flex justify-content-center align-items-center' style={{height: '90vh'}}>
        <form onSubmit={validarAcceso} className='border rounded-3 p-2 shadow' style={{width: '300px', background: 'linear-gradient(340deg,rgba(9, 67, 121, 1) 60%, rgba(0, 212, 255, 1) 100%)'}}>
          <img className='m-auto mb-1' style={{width: '150px'}} src={require('../img/img-logo-swimmingt.webp')} alt="logo" />
          <input type="text" name='codigo' className='form-control' placeholder='Código de acceso' required/>
          <hr className='my-1'/>
          <Button type='submit' icon='pi pi-check-circle' label='Acceso' className='w-100 btn btn-success'/>
        </form>
      </div>
    ):(
      <>
        <motion.div
        initial={{ opacity: 0}}
        animate={{ opacity: 1}}
        transition={{duration: 1}}
        >
          <ul className="nav nav-tabs" style={{background: 'linear-gradient(340deg,rgba(9, 67, 121, 1) 60%, rgba(0, 212, 255, 1) 100%)'}}>
            {cantJornada.length !== 0 ?(
              cantJornada.map((jornada, indexJor)=>{
                return <li className="nav-item" key={indexJor}>
                <button className={`nav-link ${jornada === (indexJornada + 1) ? "active" : ""}`}
                onClick={() => sacarIndexJornada(indexJor)}
                >{`Jornada ${jornada}`}</button>
              </li>
              })
            ):(
              <></>
            )}
            {usuario.nombreclub === 'PROWEBSPORTS' && (
              <li className='nav-item d-flex align-items-center px-1' style={{cursor: 'pointer'}} onClick={() => setDialogVoces(true)}>
                <span>Conf. Llamados</span>
              </li>
            )}
          </ul>
          {torneoEspecifico.cronometros === 'si' ?(
            <div className="sticky-top w-100">
              <div className="accordion" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingOne">
                    <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                      Asignar Prueba y Serie
                    </button>
                  </h2>
                  <div id="collapseOne" className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                    <div className="accordion-body">
                      <div className='d-flex justify-content-start'>
                        <div className="form-check form-switch">
                          <input className="form-check-input" type="checkbox" id="flexSwitchCheckDefault" onClick={() => setAutomatico(!automatico)}/>
                          <label className="form-check-label" htmlFor="flexSwitchCheckDefault">Automático</label>
                        </div>
                      </div>
                      <div className='d-flex flex-wrap justify-content-center'>
                        <div className="form-floating m-1">
                          <input className='form-control' id='prueba' type="number" defaultValue={prueba} />
                          <label htmlFor={`prueba`}>No. Prueba</label>
                        </div>
                        <div className="form-floating m-1">
                          <input className='form-control' id='serie' type="number" defaultValue={serie} />
                          <label htmlFor={`serie`}>No. Serie</label>
                        </div>
                      </div>
                      <hr className='m-0'/>
                      <Button icon='pi pi-check-circle' label='Asignar Prueba y Serie' className='btn btn-success mt-1' onClick={() => asignarJPS()}></Button>
                    </div>
                  </div>
                </div>
              </div>
              <div className='d-flex flex-wrap justify-content-around aling-items-center mt-1'>
                {Object.keys(datosCronometros).map((carril) => (
                  <Cronometro
                    key={carril}
                    datos={datosCronometros[carril]}
                    prueba={prueba}
                    serie={serie}
                    torneoEspecifico={torneoEspecifico}
                  />
                ))}
              </div>
            </div>
          ):(
            <></>
          )}
          {cantJornada.length !== 0 ?(
            <TablaTiempos 
            pruebas={pruebasCompletas[indexJornada]} 
            nadadores={nadadoresCarriles.length !== 0 ? nadadoresCarriles : []} 
            idTorneoParticipando={idTorneoParticipando} 
            torneoEspecifico={torneoEspecifico}
            tiemposRegistrados={tiemposRegistrados} 
            setTiemposRegistrados={setTiemposRegistrados}
            listadoCategorias={listadoCategorias}
            formulariosRef={formulariosRef}
            seriesRef={seriesRef}
            recordsEvento={recordsEvento}
            fechaGoogle={fechaGoogle}
            hablarPreventivo={hablarPreventivo}
            hablarPausar={hablarPausar}
            hablarDefinitivo={hablarDefinitivo}
            voz={voz}/>
          ):(
            <></>
          )}
        </motion.div>
        <Dialog visible={dialogVoces} style={{ width: '50em' }} breakpoints={{ '641px': '100%' }} header='Configuración de voces' modal className="p-fluid" onHide={() => setDialogVoces(false)}>
          <div className="field">
            <form>
              <div>
                <div className="form-floating mb-1">
                  <select className='form-select' defaultValue={voz} onChange={(ev) => setVoz(ev.target.value)}>
                    <option value="">Elige</option>
                    {voces && (
                      voces.map((v, indexV)=>{
                        return <option key={indexV} value={v.name}>{v.name}</option>
                      })
                    )}
                  </select>
                  <label htmlFor='voces'>Voces</label>
                </div>
                <div className="form-floating">
                  <input type="text" className='form-control' id='velocidadvoz' defaultValue={vozVelocidad} onChange={(e) => setVozVelocidad(e.target.value)}/>
                  <label htmlFor='velocidadvoz'>Velocidad Voz</label>
                </div>
              </div>
            </form>
          </div>
        </Dialog>
      </>
    )
  );
}

export default Tiempos;